import React from "react";
import api from "../../Constants/api";
import childLetterConst, { SPONSOR_LETTER } from "../../Constants/childLetter";

const DocumentListItem = ({ index, type, files, click }) => {
    const photo_url = files.url;
    const dateUploaded = files.updated_at;

    // console.log(index, type, files, click);

    function getLetterName(code) {
        if (!code) return;

        const letterName = childLetterConst.filter(letter => {
            return letter.code === code;
        });

        if (letterName[0] !== undefined) {
            return letterName[0].label;
        }

        return "";
    }

    function actions() {
        return (
            <>
                <a
                    href={photo_url}
                    title="file line"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {getLetterName(files.short_name) +
                        " " +
                        dateUploaded.split(" ")[0]}
                </a>
                <div className="action">
                    <a
                        href={photo_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="view"
                    >
                        <i className="fas fa-search" />
                    </a>

                    <a
                        href={
                            api.urlV2 +
                            "/child/download-child-file?childPhotoLink=" +
                            photo_url
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        title="download"
                    >
                        <i className="fas fa-file-download" />
                    </a>
                </div>
            </>
        );
    }

    function typeCl() {
        return (
            <>
                <a
                    href="#view"
                    title="file line"
                    onClick={e => click(e, index)}
                >
                    {dateUploaded.split(" ")[0]}
                </a>
                <div className="action">
                    <a
                        href={photo_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="view"
                        onClick={e => click(e, index)}
                    >
                        <i className="fas fa-external-link-alt" />
                    </a>
                </div>
            </>
        );
    }

    return (
        <div className="document-viewer-item">
            <div className="row">
                {type === SPONSOR_LETTER.code ? typeCl() : actions()}
            </div>
        </div>
    );
};

export default DocumentListItem;
